import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import NotFoundImagePlaceholder from "../../Assets/images/illustrations/not_found_image_placeholder.svg";

export const IconInputCard = (props) => {
    const {
        icon,
        className,
        isImage = false,
        children,
        showArrow = false,
        otherImage = null,
        onClick = () => {}
    } = props;

    return (
        <div className={`flex flex-row rounded-lg border border-gray-200 p-2 gap-4 ${showArrow ? 'cursor-pointer' : ''} ${className}`} onClick={onClick}>
            {
                isImage &&
                <div className={'w-12 min-w-12'}>
                    <img src={otherImage ? otherImage : NotFoundImagePlaceholder} alt={'User'} className={'w-12 h-12 rounded-lg z-10'}/>
                </div>
            }

            {
                !isImage &&
                <div className={'w-12 flex flex-col justify-center'}>
                    <div className={'relative rounded-lg w-10 h-10 mr-4 flex flex-col justify-center'}>
                        <div className={'absolute top-0 left-0 bg-primary opacity-20 w-full h-full rounded-lg'}>&nbsp;</div>
                        <FontAwesomeIcon icon={icon} className={'text-primary m-auto z-10'}/>
                    </div>
                </div>
            }

            <div className={'flex flex-col justify-center w-full'}>
                {children}
            </div>

            {
                showArrow &&
                <div className={'w-12 flex flex-col justify-center'}>
                    <div className={'relative rounded-lg w-6 h-6 ml-4 flex flex-col justify-center my-auto'}>
                        <div className={'absolute top-0 left-0 bg-primary opacity-20 w-full h-full rounded-full'}>&nbsp;</div>
                        <FontAwesomeIcon icon={faArrowRight} className={'text-primary m-auto z-10 text-md'}/>
                    </div>
                </div>
            }
        </div>
    )
}